/*
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import BachCenteredBlogCard from "bachrosenComponents/bachCenteredBlogCard";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import DefaultNavbar from "bachrosenComponents/bachNavbar";
import CenteredFooter from "bachrosenComponents/centeredFooter";
// import HorizontalBlogCard from "examples/Cards/BlogCards/HorizontalBlogCard";
import BachHeader from "bachrosenComponents/bachHeader";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Images
import bgImage from "assets/images/home1.jpg";
import galleryImage1 from "assets/images/gallery1.jpg";
import galleryImage2 from "assets/images/gallery2.jpg";
import galleryImage3 from "assets/images/gallery3.jpg";
import galleryImage4 from "assets/images/gallery4.jpg";
import galleryImageTreffen from "assets/images/gallery-treffen.jpg";
// import galleryImage5 from "assets/images/news_narrentreffen5.jpg";

function GallerySite() {
  return (
    <>
      <MKBox position="fixed" top="0.5rem" width="100%">
        <DefaultNavbar routes={routes} dark info center />
      </MKBox>
      <BachHeader image={bgImage} title="Galerie" />
      {/* <MKBox
        minHeight="75vh"
        width="100%"
        sx={{
          backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
            `${linearGradient(
              rgba(gradients.dark.main, 0.6),
              rgba(gradients.dark.state, 0.6)
            )}, url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "grid",
          placeItems: "center",
        }}
      >
        <MKTypography
          align="center"
          variant="h1"
          color="white"
          sx={({ breakpoints, typography: { size } }) => ({
            [breakpoints.down("md")]: {
              fontSize: size["3xl"],
            },
          })}
        >
          Gallerie
        </MKTypography>
      </MKBox> */}

      <Card
        sx={{
          // p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <Container>
          <Grid
            container
            spacing={3}
            // direction="column"
            alignItems="center"
            justifyContent="center"
            mt={2}
            mb={8}
          >
            <Grid item xs={12} lg={6} mt={8}>
              <a
                // href="https://photos.app.goo.gl/cFpnogQZMTMVpjgG9"
                href="https://photos.app.goo.gl/ugueten5d89JbphR6"
                target="_blank"
                rel="noreferrer"
              >
                <BachCenteredBlogCard
                  image={galleryImageTreffen}
                  title="Narrentreffen 2024"
                  description="Klicken, um Album anzuzeigen"
                />
              </a>
            </Grid>
            <Grid item xs={12} lg={6} mt={8}>
              <a
                href="https://photos.app.goo.gl/mbhVPBJvJ3YBGW4A8"
                target="_blank"
                rel="noreferrer"
              >
                <BachCenteredBlogCard
                  image={galleryImage1}
                  title="Umzüge"
                  description="Klicken, um Album anzuzeigen"
                />
              </a>
            </Grid>
            <Grid item xs={12} lg={6} mt={8}>
              <a
                href="https://photos.app.goo.gl/EHh7GBBzw3GJmZYT8"
                target="_blank"
                rel="noreferrer"
              >
                <BachCenteredBlogCard
                  image={galleryImage2}
                  title="Zunftbälle"
                  description="Klicken, um Album anzuzeigen"
                />
              </a>
            </Grid>
            <Grid item xs={12} lg={6} mt={8}>
              <a
                href="https://photos.app.goo.gl/5XkSZq6uNDVADHfG9"
                target="_blank"
                rel="noreferrer"
              >
                <BachCenteredBlogCard
                  image={galleryImage4}
                  title="Schmotziger und mehr"
                  description="Klicken, um Album anzuzeigen"
                />
              </a>
            </Grid>
            <Grid item xs={12} lg={6} mt={8}>
              <a href="https://goo.gl/photos/TTRuKkJGAa9Y8Dfc6" target="_blank" rel="noreferrer">
                <BachCenteredBlogCard
                  image={galleryImage3}
                  title="Aktivitäten außerhalb der Fasnacht"
                  description="Klicken, um Album anzuzeigen"
                />
              </a>
            </Grid>
          </Grid>
        </Container>
      </Card>
      <MKBox px={1} mt={6}>
        <CenteredFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default GallerySite;
